import "./consult.css";
import Seo from "../../components/seo/Seo";

const pillars = [
    {
        title: "Beweging",
        text:
            "Regelmatig bewegen is gezond en voor veel mensen ook leuk om samen te doen. Je voelt je lichamelijk en psychisch fitter, krijgt energie en ervaart vaak minder stress. Samen kijken we naar activiteiten die leuk zijn, vol te houden zijn en in te passen zijn in het dagelijks leven.",
        image: require("../../static/afbeeldingen/beweging-compressed.jpg"),
        alt: "Beweging als onderdeel van leefstijlbegeleiding in Breda",
    },
    {
        title: "Voeding",
        text:
            "Om goed voor uzelf te zorgen is gezonde voeding belangrijk. Er zijn veel ziektebeelden waarbij met de juiste voedingsaanpassingen klachten kunnen verminderen. Denk bijvoorbeeld aan Diabetes Mellitus, COPD, ondervoeding, buikklachten, lactose-intolerantie, hart- en vaatziekten, hypertensie en migraine.",
        image: require("../../static/afbeeldingen/voeding-compressed.jpg"),
        alt: "Voedingsadvies en dieetadvies van diëtist in Breda",
    },
    {
        title: "Ontspanning",
        text:
            "Iedereen heeft wel eens stress. Maar als stress te veel ruimte inneemt kan ontspannen lastiger worden. Door op tijd en genoeg te ontspannen kan het lichaam beter herstellen. We kijken naar verschillende manieren om te ontspannen zodat ze een positieve bijdrage leveren aan een gezondere leefstijl.",
        image: require("../../static/afbeeldingen/ontspanning-compressed.jpg"),
        alt: "Ontspanning en balans bij leefstijlbegeleiding",
    },
];

export default function Consult() {
    return (
        <>
            <Seo
                title="Voedingsadvies en dieetadvies in Breda"
                description="Lees meer over consulten voor voedingsadvies, dieetadvies en leefstijlbegeleiding bij Vandaag Begin Ik, diëtist in Breda."
                path="/consult"
            />

            <section className="page-intro">
                <p className="section-label">Consult</p>
                <h1>Leefstijlbegeleiding rond voeding, beweging en ontspanning.</h1>
                <p>
                    Een consult voor voedingsadvies of dieetadvies is gericht op keuzes die vol te
                    houden zijn en die passen bij uw gezondheid, ritme en dagelijks leven.
                </p>
            </section>

            <section className="consult-grid">
                {pillars.map((pillar) => (
                    <article className="consult-card" key={pillar.title}>
                        <img src={pillar.image} alt={pillar.alt} />
                        <div className="consult-card__content">
                            <h2>{pillar.title}</h2>
                            <p>{pillar.text}</p>
                        </div>
                    </article>
                ))}
            </section>

            <section className="policy-section">
                <div className="policy-card">
                    <p className="section-label">Vergoeding</p>
                    <h2>Vergoeding en voorwaarden</h2>
                    <p>
                        Dieetadvisering met een medische indicatie wordt vergoed voor 3 uur vanuit de
                        basisverzekering. Wel gebruikt u eerst uw eigen risico.
                    </p>
                    <p>
                        Bij een aanvullende verzekering wordt de dieetadvisering vaak aangevuld met meer
                        uren.
                    </p>
                    <p>
                        Vandaag Begin Ik heeft contracten met alle zorgverzekeraars zodat er rechtstreeks
                        kan worden gedeclareerd.
                    </p>
                    <p>
                        Afspraken kunnen tot 24 uur voor het consult kosteloos worden geannuleerd. De
                        kosten zullen voor eigen rekening zijn indien de afspraak niet tijdig wordt
                        geannuleerd.
                    </p>
                    <div className="policy-links">
                        <a href="/AlgemeneVoorwaarden.pdf" target="_blank" rel="noreferrer">
                            Algemene voorwaarden
                        </a>
                        <a href="/Privacyverklaring.pdf" target="_blank" rel="noreferrer">
                            Privacyverklaring
                        </a>
                    </div>
                </div>
            </section>
        </>
    );
}
